import {
  UPDATE_DOCTOR_EARNING,
  UPDATE_DOCTOR_EARNING_SUCCESS,
  UPDATE_DOCTOR_EARNING_FAILURE,
} from 'store/updateDoctorEarning/updateDoctorEarningAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const updateDoctorEarningReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DOCTOR_EARNING:
      return { ...state, loading: true };
    case UPDATE_DOCTOR_EARNING_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case UPDATE_DOCTOR_EARNING_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default updateDoctorEarningReducer;
